import { render, staticRenderFns } from "./selfInfo.vue?vue&type=template&id=5fcc9732"
import script from "./selfInfo.vue?vue&type=script&lang=js"
export * from "./selfInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports